import {
  IbmIcon
} from "./chunk-5KE2MQJT.mjs";
export {
  IbmIcon
};
